import { isBrowser } from "@/utils";
import importWithRetry from "@/utils/helpers/importWithRetry";

let appNavigation = null;

const loadAppNavModule = () => {
  window.addEventListener("load", async () => {
    try {
      appNavigation = await importWithRetry(() => import("$app/navigation"));
    } catch (err) {
      console.warn(err);
    }
  });
};

if (isBrowser()) {
  loadAppNavModule();
}

function goto(url) {
  if (appNavigation?.goto) {
    return appNavigation.goto(url);
  }
  window.location.href = url;
}

function beforeNavigate(fun) {
  if (appNavigation?.beforeNavigate) {
    return appNavigation.beforeNavigate(fun);
  }
}

export { goto, beforeNavigate };
